import {
  sendMemberVerificationCode,
  resetMemberPassword
} from "@root/graphql/forgetPassword.gql";
import {
  K1_PCR_apolloClient,
  K1_TBR_apolloClient,
  K1_YGJ_apolloClient
} from "@root/lib/allApolloClient";

import { httpServer as ygjHttp } from "@root/lib/axios/ygjAxios";
export default {
  namespaced: true,
  state: {},
  actions: {
    async sendMemberVerificationCode({ rootState }: any, data?: any) {
      let res = await K1_YGJ_apolloClient.mutate({
        mutation: sendMemberVerificationCode,
        variables: { ...data }
      });
    },
    async resetMemberPassword({ rootState }: any, data?: any) {
      let res = await K1_YGJ_apolloClient.mutate({
        mutation: resetMemberPassword,
        variables: { ...data }
      });
    },
    // 子账号迭代-更换重置密码接口
    async resetMemberPassword2({ rootState }, params = {}) {
      const data = await ygjHttp({
        url: "/account/password-forget",
        params
      });
    },
    // 子账号迭代-更换重置密码接口
    async sendMsg({ rootState }, params = {}) {
      const data = await ygjHttp({
        url: "/account/password-forget/dynamic-code",
        params
      });
    }
  },
  mutations: {}
};
